// @ts-nocheck
import * as React from 'react';
import moment from 'moment';
import NooderaButton from 'components/NooderaButton/index';
import CheckIcon from '@mui/icons-material/Check';
import { getTheme } from 'settings/theme/index';
import type { SectionCardItemProps } from './SectionCardItem.types';
import {
  StyledSimpleCard,
  StyledTag,
  SimpleCardContent,
  SimpleCardTag,
  SimpleCardButton,
} from './SectionCardItem.styles';

const SectionCardItem = ({
  item,
  selected,
  onChange,
}: SectionCardItemProps): React.ReactElement<any> => (
  <StyledSimpleCard key={item?.id}>
    <StyledTag inline>Team</StyledTag>
    <SimpleCardContent>
      <span>{item?.name}</span>
      <span>{`Currently ${item?.acceptedMembersCount} Members`}</span>
      <span>Starts {moment(item?.startDate).format('ll')}</span>
      <SimpleCardTag
        img={item?.admin?.avatar}
        alt=''
        title={`${item?.admin?.firstName} ${item?.admin?.lastName}`}
        subtitle='Owner'
        size='48px'
        customFont={getTheme().noodera.fontTypes.font5Medium}
      />
    </SimpleCardContent>
    <SimpleCardButton>
      <NooderaButton size='large' onClick={() => onChange(item)}>
        {selected === item?.id ? (
          <>
            <CheckIcon /> Selected
          </>
        ) : (
          'Select'
        )}
      </NooderaButton>
    </SimpleCardButton>
  </StyledSimpleCard>
);

export default SectionCardItem;
